// Poptávkový formulář – přístupná validace (WCAG 3.3.1, 3.3.3): chyba u pole, aria-invalid, fokus na první chybu
(() => {
    const messages = {
        valueMissing: {
            jmeno: "Vyplňte prosím jméno a příjmení.",
            telefon: "Vyplňte prosím telefon, ať vám můžeme zavolat.",
            email: "Vyplňte prosím e-mail.",
            gdpr: "Pro odeslání poptávky potřebujeme váš souhlas.",
        },
        typeMismatch: {
            email: "Zadejte e-mail ve tvaru jmeno@domena.cz.",
        },
    };

    const messageFor = (field) => {
        const v = field.validity;
        if (v.valueMissing) {
            const label = field.closest(".form-field")?.querySelector("label")?.firstChild?.textContent.trim();
            return messages.valueMissing[field.name] || (label ? "Vyplňte prosím pole „" + label + "“." : "Toto pole je povinné.");
        }
        if (v.typeMismatch) return messages.typeMismatch[field.name] || "Zkontrolujte prosím formát.";
        return field.validationMessage;
    };

    const setError = (field, text) => {
        const id = field.id + "-error";
        let error = document.getElementById(id);
        const host = field.closest(".form-field, .form-consent");

        if (!text) {
            field.removeAttribute("aria-invalid");
            if (error) error.remove();
            field.setAttribute("aria-describedby", (field.getAttribute("aria-describedby") || "").replace(id, "").trim());
            if (!field.getAttribute("aria-describedby")) field.removeAttribute("aria-describedby");
            return;
        }

        if (!error) {
            error = document.createElement("p");
            error.id = id;
            error.className = "field-error";
            host.insertAdjacentElement(host.classList.contains("form-consent") ? "afterend" : "beforeend", error);
        }
        error.innerHTML = '<i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i><span>' + text + "</span>";
        field.setAttribute("aria-invalid", "true");
        const described = (field.getAttribute("aria-describedby") || "").split(" ").filter(Boolean);
        if (!described.includes(id)) described.push(id);
        field.setAttribute("aria-describedby", described.join(" "));
    };

    // Stav odeslání – jedno živé hlášení pod tlačítkem (WCAG 4.1.3)
    const status = (form, ok, text) => {
        let box = form.querySelector(".form-status");
        if (!box) {
            box = document.createElement("p");
            box.setAttribute("role", ok ? "status" : "alert");
            form.appendChild(box);
        }
        box.className = "form-status " + (ok ? "form-success" : "form-failure");
        box.innerHTML = '<i class="fa-solid ' + (ok ? "fa-circle-check" : "fa-circle-exclamation") + '" aria-hidden="true"></i><span></span>';
        box.lastChild.textContent = text;
    };

    // reCAPTCHA v3 – skript se stahuje až při práci s formulářem a token se bere těsně před odesláním (platí 2 minuty)
    let recaptchaLoading = null;
    const loadRecaptcha = (key) => {
        if (window.grecaptcha) return Promise.resolve();
        if (recaptchaLoading) return recaptchaLoading;
        recaptchaLoading = new Promise((resolve, reject) => {
            const s = document.createElement("script");
            s.src = "https://www.google.com/recaptcha/api.js?render=" + encodeURIComponent(key);
            s.async = true;
            const timer = setTimeout(() => reject(new Error("timeout")), 10000);
            s.onload = () => { clearTimeout(timer); resolve(); };
            s.onerror = () => { clearTimeout(timer); reject(new Error("load failed")); };
            document.head.appendChild(s);
        });
        recaptchaLoading.catch(() => { recaptchaLoading = null; });
        return recaptchaLoading;
    };
    const fillRecaptcha = async (form) => {
        const key = form.dataset.recaptchaKey;
        const field = form.querySelector('input[name="g-recaptcha-response"]');
        if (!key || !field) return;
        try {
            await loadRecaptcha(key);
            await new Promise((resolve) => window.grecaptcha.ready(resolve));
            field.value = await window.grecaptcha.execute(key, { action: form.dataset.recaptchaAction || "submit" });
        } catch (err) {
            // Server si token ověří sám – lepší poslat poptávku bez tokenu než ji kvůli výpadku cizího skriptu ztratit
            console.warn("[reCAPTCHA] token se nepodařilo získat", err);
        }
    };

    // Odeslání přes FormData (kvůli přílohám); odpověď {ok, error} z /api/lead/submit
    const submit = async (form) => {
        const btn = form.querySelector('button[type="submit"]');
        btn.disabled = true;
        btn.setAttribute("aria-busy", "true");
        await fillRecaptcha(form);
        try {
            const res = await fetch(form.action, { method: "POST", body: new FormData(form), headers: { "X-Requested-With": "XMLHttpRequest" } });
            let data = {};
            try { data = await res.json(); } catch { /* v dev režimu může PHP warning rozbít JSON */ }
            if (res.ok && data.ok) {
                form.reset();
                status(form, true, "Děkujeme, poptávku jsme přijali. Ozveme se vám co nejdříve.");
            } else {
                status(form, false, data.error || "Odeslání se nepovedlo. Zkuste to prosím znovu, nebo nám zavolejte.");
            }
        } catch {
            status(form, false, "Odeslání se nepovedlo. Zkuste to prosím znovu, nebo nám zavolejte.");
        }
        btn.disabled = false;
        btn.removeAttribute("aria-busy");
    };

    document.querySelectorAll(".contact-form").forEach((form, index) => {
        if (form.dataset.recaptchaKey) {
            const warm = () => loadRecaptcha(form.dataset.recaptchaKey).catch(() => {});
            ["pointerover", "focusin", "touchstart"].forEach((ev) => form.addEventListener(ev, warm, { once: true, passive: true }));
        }
        form.noValidate = true;
        const fields = [...form.querySelectorAll("input[required], textarea[required], select[required]")];
        fields.forEach((field) => {
            if (!field.id) field.id = "f-field-" + index + "-" + field.name;
            field.addEventListener("blur", () => {
                if (field.getAttribute("aria-invalid") === "true") setError(field, field.checkValidity() ? "" : messageFor(field));
            });
            field.addEventListener("change", () => {
                if (field.getAttribute("aria-invalid") === "true") setError(field, field.checkValidity() ? "" : messageFor(field));
            });
        });

        form.addEventListener("submit", (e) => {
            let firstInvalid = null;
            fields.forEach((field) => {
                const ok = field.checkValidity();
                setError(field, ok ? "" : messageFor(field));
                if (!ok && !firstInvalid) firstInvalid = field;
            });

            if (firstInvalid) {
                e.preventDefault();
                firstInvalid.focus();
                return;
            }

            e.preventDefault();
            submit(form);
        });
    });
})();
